import React from 'react'
import Header from '../../Global/Header'
import Footer from '../../Global/Footer'
import Gototop from '../../Global/Gototop'
import Bredcump from '../../Global/Bredcump'
import ChangelogList from './ChangelogList'
import { brandUrl } from '../../../constants/brand'
import { CHANGELOG } from '../../../content/changelog'

const Main = () => {
  return (
    <>
      <Header />
      <Bredcump
        Heading="Updates"
        Title="Changelog"
        Subtitle="Changelog"
        Description={CHANGELOG.intro}
      />
      <section className="row_am section_inner_padding changelog_section">
        <div className="container">
          <ChangelogList />
          <p className="changelog_store_note" data-aos="fade-up" data-aos-duration={1500}>
            {CHANGELOG.storeNote}
          </p>
          <p className="changelog_roadmap_link" data-aos="fade-up" data-aos-duration={1500}>
            See what we are building on the{' '}
            <a href={brandUrl('roadmap')} target="_blank" rel="noopener noreferrer">
              roadmap
            </a>
            .
          </p>
        </div>
      </section>
      <Footer />
      <Gototop />
    </>
  )
}

export default Main
